import {
  ISolicitante,
  cSolicitante,
  eTipoIdentificador,
} from "./solicitante.modelo";
import { IDocumento } from "./tramite.modelo";
import Swal from "sweetalert2";

// Estados de la cita en texto descriptivo
export function EstadoCitaToString(Estado: string): string {
  let sEstado = "";
  switch (Estado) {
    case "P":
      sEstado = "Pendiente";
      break;
    case "R":
      sEstado = "Realizada";
      break;
    case "N":
      sEstado = "Anulada";
      break;
    case "X":
      sEstado = "No acude";
      break;
  }
  return sEstado;
}

// Interfaz con los datos de la cita
export interface ICita {
  id_cita: number;
  // id_fk_solicitante: number;
  DTO_AREA: string;
  PERSONA: string;
  ticket: string;
  fecha: number;
  HHMM: string;
  estado: string;
  motivo: string;
  TRAMITE: string;
  INFO_TRAMITE: string;
  DOCUMENTOS: IDocumento[];
  REPRESENTADO: ISolicitante;
  telematica: boolean;
  url_video_solicitante: string;
}

// Interfaz con el detalle de la cita que se muestra al finalizar
// el proceso de cita, envío de email o impresión
export interface IDetalleCita {
  id_cita: number;
  AREA: string;
  FECHA_HORA_CITA: string;
  ticket: string;
  estado: string;
  TRAMITE: string;
  DOCUMENTACION: string[];
  SOLICITANTE_NIF: string;
  SOLICITANTE: string;
  SOLICITANTE_TLF1: string;
  SOLICITANTE_TLF2: string;
  SOLICITANTE_EMAIL: string;
  REPRESENTADO_NIF: string;
  REPRESENTADO_EMAIL: string;
  MOTIVO_CITA: string;
  telematica: boolean;
  id_video: string;
  url_video_solicitante: string;
}

// Clase con el detalle de la cita
export class cDetalleCita implements IDetalleCita {
  public id_cita: number;
  public AREA: string;
  public FECHA_HORA_CITA: string;
  public ticket: string;
  public estado: string;
  public TRAMITE: string;
  public INFO_TRAMITE: string;
  public DOCUMENTACION: string[];
  public SOLICITANTE_NIF: string;
  public SOLICITANTE: string;
  public SOLICITANTE_TLF1: string;
  public SOLICITANTE_TLF2: string;
  public SOLICITANTE_EMAIL: string;
  public REPRESENTADO_NIF: string;
  public REPRESENTADO_EMAIL: string;
  public MOTIVO_CITA: string;
  public telematica: boolean;
  public id_video: string;
  public url_video_solicitante: string;
  constructor() {
    this.id_cita = 0;
    this.AREA = "";
    this.FECHA_HORA_CITA = "";
    this.ticket = "";
    this.estado = "";
    this.TRAMITE = "";
    this.INFO_TRAMITE = "";
    this.DOCUMENTACION = [];
    this.SOLICITANTE_NIF = "";
    this.SOLICITANTE = "";
    this.SOLICITANTE_TLF1 = "";
    this.SOLICITANTE_TLF2 = "";
    this.SOLICITANTE_EMAIL = "";
    this.REPRESENTADO_NIF = "";
    this.REPRESENTADO_EMAIL = "";
    this.MOTIVO_CITA = "";
    this.telematica = false;
    this.id_video = "";
    this.url_video_solicitante = "";
  }
}

// Interfaz que obtiene la precita bloqueada
export interface IPrecitaBloqueo {
  id_pre_cita_bloqueo: number;
  id_pre_cita: number;
  HORA: string; //"HH:MM"
}

// Interfaz que se enviará para la creación de la cita
export interface ICrearCita {
  id_pre_cita_bloqueo: number;
  id_fk_tramite: number;
  tiponif: eTipoIdentificador;
  nif: string;
  nombre: string;
  apellido1: string;
  apellido2: string;
  email: string;
  tlf1: string;
  tlf2: string;
  ID_REPRESENTADO: number;
  TIPONIF_REP: eTipoIdentificador;
  NIF_REP: string;
  NOMBRE_REP: string;
  APELLIDO1_REP: string;
  APELLIDO2_REP: string;
  EMAIL_REP: string;
  TLF1_REP: string;
  TLF2_REP: string;
  motivo: string;
}

// Resultado que devuelve la creación de una cita
export interface IResultadoCita {
  id_cita: number;
  ticket: string;
}

// Interfaz para el botón añadir al calendario
export interface ICitaCalendario {
  FECHA_INICIO: string;
  FECHA_FIN: string;
  TITULO: string;
  DESCRIPCION: string;
  TIMEZONE: string;
  direccion: string;
}

// Clase con el detalle de la cita
export class cCitaCalendario implements ICitaCalendario {
  public FECHA_INICIO: string;
  public FECHA_FIN: string;
  public TITULO: string;
  public DESCRIPCION: string;
  public TIMEZONE: string;
  public direccion: string;

  constructor() {
    this.FECHA_INICIO = "";
    this.FECHA_FIN = "";
    this.TITULO = "";
    this.DESCRIPCION = "";
    this.TIMEZONE = "";
    this.direccion = "";
  }
}

// Impresión o reimpresión de la cita en formato HTML
export function ImprimirCitaHTML(
  sNombreCliente: string,
  oDetalleCita: cDetalleCita,
  sEnRepresentacionDe: string
): void {
  // Genero el html con la ficha para la impresión
  const html: string = GeneraHTMLCita(
    sNombreCliente,
    oDetalleCita,
    sEnRepresentacionDe
  );
  // Muestro la ficha de la impresión en una alerta
  Swal.fire({
    html: html,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText: "Imprimir",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      // Abre una nueva ventana del navegador
      const mywindow = window.open("", "PRINT", "height=600,width=750");
      mywindow.document.open();
      // Escribe la estructura a imprimir
      mywindow.document.writeln("<html>");
      mywindow.document.writeln(GeneraCabeceraHTMLCita());
      mywindow.document.writeln("<body >");
      mywindow.document.writeln(html);
      mywindow.document.writeln("</body></html>");
      // A los dos segundos cierra la ventana para dejar solo la de impresión
      setTimeout(function () {
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10

        mywindow.print();
        // En caso de que sea un Mac no podemos cerrar la ventana
        // porque sino no podemos imprimir
        if (navigator.platform.toUpperCase().includes("MAC")) return;
        mywindow.close();
      }, 2000);
    }
  });
}

// Generación del HTML de la cita para su impresión o envío por email
export function GeneraHTMLCita(
  sNombreCliente: string,
  oDetalleCita: cDetalleCita,
  sEnReprensentacionDe: string
): string {
  let sHtml = "";

  // TODO JMUNOZ: Mirar si es necesario al imprimir el documento. Estos estilos están rompiendo el contenedor en movil.
  // Mirar si se puede separar dependiendo si es la impresión o la representación en el contenedor.
  //sHtml += '<style>';
  //sHtml += '.capa_impresion {margin: 0px auto; width: 400px; height: auto; background-color: white;  border: 1px solid #555;}';
  //sHtml += '.impresion {margin: 20px;color: black; font-size: 0.9em !important; text-align: left;}';
  //sHtml += '.impresion h1 {font-size: 1.3em; width: 100%; text-align: center;}';
  //sHtml += '.impresion h2 {font-size: 1.2em; text-align: center;}';
  //sHtml += '.impresion h3 {font-size: 1em; text-align: center; font-weight: bold;}';
  //sHtml += '.impresion p {font-size: 0.9em !important;}';
  //sHtml += '.impresion ul li { font-size: 0.9em !important;}';
  //sHtml += '</style>';

  sHtml += '<div class="capa_impresion">';
  sHtml += '  <div class="impresion">';

  sHtml += "  <h1>CITA PREVIA</h1>";
  sHtml += "  <h2>" + sNombreCliente + "</h2>";

  sHtml += "  <h3>" + oDetalleCita.FECHA_HORA_CITA + "</h3>";
  sHtml += "  <p> Ticket: " + oDetalleCita.ticket + "</p>";
  sHtml += "  <p> Área: " + oDetalleCita.AREA + "</p>";
  sHtml += "  <p>Trámite: " + oDetalleCita.TRAMITE + "</p>";
  sHtml += "  <p>Documentación que debe aportar:</p>";
  sHtml += "  <ul>";
  for (let i = 0; i <= oDetalleCita.DOCUMENTACION.length - 1; i++) {
    sHtml += "    <li>" + oDetalleCita.DOCUMENTACION[i] + "</li>";
  }
  sHtml += "  </ul>";
  sHtml +=
    '  <p style="text-decoration: underline;">Información del solicitante:</p>';
  sHtml += "  <br/>";
  sHtml += "  <p> Código Identidad: " + oDetalleCita.SOLICITANTE_NIF + "</p>";
  sHtml += "  <p> Solicitante: " + oDetalleCita.SOLICITANTE + "</p>";
  sHtml += "  <p> Teléfono Móvil: " + oDetalleCita.SOLICITANTE_TLF1 + "</p>";
  if (
    oDetalleCita.SOLICITANTE_TLF2 != null &&
    oDetalleCita.SOLICITANTE_TLF2 != undefined &&
    oDetalleCita.SOLICITANTE_TLF2 !== ""
  ) {
    sHtml += "  <p> Teléfono Fijo: " + oDetalleCita.SOLICITANTE_TLF2 + "</p>";
  }
  sHtml += "  <p>Email: " + oDetalleCita.SOLICITANTE_EMAIL + "</p>";
  if (
    oDetalleCita.MOTIVO_CITA != null &&
    oDetalleCita.MOTIVO_CITA != undefined &&
    oDetalleCita.MOTIVO_CITA !== ""
  ) {
    sHtml += "  <p>Motivo Cita:</p>";
    sHtml += "  <p>" + oDetalleCita.MOTIVO_CITA + "</p>";
  }

  sHtml += "  <br/>";
  if (
    oDetalleCita.REPRESENTADO_NIF != null &&
    oDetalleCita.REPRESENTADO_NIF != undefined &&
    oDetalleCita.REPRESENTADO_NIF !== ""
  ) {
    sHtml +=
      "  <p><i>* Actúa en representación de " +
      sEnReprensentacionDe +
      " con código identidad " +
      oDetalleCita.REPRESENTADO_NIF +
      "</i></p>";
  }
  sHtml += "  </div>";
  sHtml += "</div>";

  return sHtml;
}

// Generación del HTML de la cita para su impresión o envío por email
export function GeneraCabeceraHTMLCita(): string {
  let sHtml = "";

  sHtml += "<style>";
  sHtml +=
    ".capa_impresion {margin: 0px auto; width: 400px; height: auto; background-color: white;  border: 1px solid #555;}";
  sHtml +=
    ".impresion {margin: 20px;color: black; font-size: 0.9em !important; text-align: left;}";
  sHtml += ".impresion h1 {font-size: 1.3em; width: 100%; text-align: center;}";
  sHtml += ".impresion h2 {font-size: 1.2em; text-align: center;}";
  sHtml +=
    ".impresion h3 {font-size: 1em; text-align: center; font-weight: bold;}";
  sHtml += ".impresion p {font-size: 0.9em !important;}";
  sHtml += ".impresion ul li { font-size: 0.9em !important;}";
  sHtml += "</style>";

  return sHtml;
}
